import * as Types from '../Constants/AllConstants';


// Get all matches
export const GetAllMatchesReducer = (
  state = { matches: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.MATCH_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.MATCH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        matches: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.MATCH_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.MATCH_LIST_RESET:
      return { matches: [] };
    default:
      return state;
  }
};

// Match details
export const MatchDetailsReducer = (state = { match: {} }, action) => {
  switch (action.type) {
    case Types.MATCH_DETAILS_REQUEST:
      return { loading: true };
    case Types.MATCH_DETAILS_SUCCESS:
      return { loading: false, match: action.payload };
    case Types.MATCH_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create match
export const CreateMatchReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MATCH_CREATE_REQUEST:
      return { loading: true };
    case Types.MATCH_CREATE_SUCCESS:
      return { loading: false, success: true, match: action.payload };
    case Types.MATCH_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MATCH_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update match
export const UpdateMatchReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MATCH_UPDATE_REQUEST:
      return { loading: true };
    case Types.MATCH_UPDATE_SUCCESS:
      return { loading: false, success: true, match: action.payload };
    case Types.MATCH_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MATCH_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete match
export const DeleteMatchReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MATCH_DELETE_REQUEST:
      return { loading: true };
    case Types.MATCH_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.MATCH_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MATCH_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Get live matches
export const GetLiveMatchesReducer = (state = { matches: [], pages: 0, page: 0, totalItems: 0 }, action) => {
  switch (action.type) {
    case Types.MATCH_LIVE_REQUEST:
      return { ...state, loading: true };
    case Types.MATCH_LIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        matches: action.payload,
        pages: action.payload?.totalPages ?? 0,
        page: action.payload?.number ?? 0,
        totalItems: action.payload?.totalElements ?? action.payload?.content?.length ?? 0,
      };
    case Types.MATCH_LIVE_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get upcoming matches
export const GetUpcomingMatchesReducer = (
  state = { matches: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.MATCH_UPCOMING_REQUEST:
      return { ...state, loading: true };
    case Types.MATCH_UPCOMING_SUCCESS:
      return {
        ...state,
        loading: false,
        matches: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.MATCH_UPCOMING_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get featured matches
export const GetFeaturedMatchesReducer = (
  state = { matches: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.MATCH_FEATURED_REQUEST:
      return { ...state, loading: true };
    case Types.MATCH_FEATURED_SUCCESS:
      return {
        ...state,
        loading: false,
        matches: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.MATCH_FEATURED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Update match score
export const UpdateMatchScoreReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MATCH_UPDATE_SCORE_REQUEST:
      return { loading: true };
    case Types.MATCH_UPDATE_SCORE_SUCCESS:
      return { loading: false, success: true, match: action.payload };
    case Types.MATCH_UPDATE_SCORE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MATCH_UPDATE_SCORE_RESET:
      return {};
    default:
      return state;
  }
};

// Match statistics
export const GetMatchStatisticsReducer = (state = { statistics: {} }, action) => {
  switch (action.type) {
    case Types.MATCH_STATISTICS_REQUEST:
      return { loading: true };
    case Types.MATCH_STATISTICS_SUCCESS:
      return { loading: false, statistics: action.payload };
    case Types.MATCH_STATISTICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
